import { Component } from '@angular/core';
import { ApiService } from './core/services';

@Component({
  selector: 'app-root',
  template: '<ngx-ui-loader></ngx-ui-loader><div ngxUiLoaderBlurred><router-outlet></router-outlet></div><cookie-law learnMore={{this.privacyPolicy}}></cookie-law>',
})


export class AppComponent {
  title = 'sa';
  solutionName: any;
  favicon: any;
  privacyPolicy: any;

  constructor(private apiService: ApiService) {

    const getOrganizationAccountService = this.apiService.getGuestOrganizationAccount()
      .subscribe(
        data => {
          this.solutionName = data.name;
          this.favicon = data.favicon;
          this.privacyPolicy = data.privacyPolicyLink;

          $("#pageTitle").text(this.solutionName);
          $("#faviconId").attr("href", `data:image/png;base64,${this.favicon}`);

          getOrganizationAccountService.unsubscribe();
        },
        error => {
          $("#pageTitle").text("title");
          getOrganizationAccountService.unsubscribe();
        });

  }

}



